import type { EventNames, EventNamesType, EventsType } from '@westwing/appshell_types';
import { MicrofrontendBrazeCustomEvent } from './types';

export const dispatchCustomEvent = <T extends EventNamesType>(evtName: T, data: EventsType[T]): void => {
    window.document.dispatchEvent(new CustomEvent<EventsType[EventNames]>(evtName, data));
};

export const sendBrazeCustomEvent = ({ name, properties = {} }: MicrofrontendBrazeCustomEvent): void => {
    dispatchCustomEvent('SEND_BRAZE_CUSTOM_EVENT', {
        detail: {
            action: 'SEND',
            // eslint-disable-next-line camelcase
            event: { name, properties: { ...properties, source_details: 'mf-signup-and-login' } },
        },
    });
};
